<template>
  <label for="input-file">{{ labelText }}</label>
  <input
    ref="fileInput"
    type="file"
    @change="pickFile"
    id="input-file"
    accept=".pdf, .docx, .jpeg, .png"
    style="display: none"
    multiple
  />

  <div :class="error ? 'error' : null" class="upload-files" @click="$refs.fileInput.click()">
    <div class="header">
      <IconUpload height="32px" width="32px" color="#333"></IconUpload>
      <span style="color: #333">Cliquez pour téléverser un fichier</span>
      <span style="color: rgba(0,0,0,0.4)">Vous pouvez upload jusqu'à 5 fichiers</span>
    </div>
    <div class="files" v-for="file in state[keyStore].files" :key="file">
      <div class="file">
        {{ file.name }}
        <button id="delete-file" @click.stop.prevent="removeFile(file.name)">
          <IconDelete height="24px" width="24px" color="#333"></IconDelete>
        </button>
      </div>
    </div>
    <div v-if="isLimitFilesCross" style="text-align: center; margin: 0">
      <span
        style="color: red; border: 1px solid crimson; padding: 0.25rem; border-radius: 5px;"
      >5 fichiers maximum</span>
    </div>
  </div>
</template>

<script>
import { state } from '../../store';
import { watch, ref } from 'vue';
import IconUpload from '../Icons/IconUpload.vue';
import IconDelete from '../Icons/IconDelete.vue';

export default {
  name: "InputFile",
  components: { IconUpload, IconDelete },
  props: {
    keyStore: {
      type: String
    },
    labelText: {
      type: String
    },
    error: {
      type: Boolean
    }
  },
  setup(props) {

    const isLimitFilesCross = ref(false);
    const maxFiles = 5;

    const pickFile = (pickedFile) => {
      for (let i = 0; i < pickedFile.target.files.length; i++) {
        if (state[props.keyStore].files.length === maxFiles) {
          return;
        } else {
          state[props.keyStore].files.push(pickedFile.target.files[i]);
        }
      }
    }

    const removeFile = (fileName) => {
      let files = Array.from(state[props.keyStore].files);

      for (let i = 0; i < files.length; i++) {
        if (files[i].name === fileName) {
          files.splice(i, 1);
        }
      }
      state[props.keyStore].files = files;
    }

    watch(() => state[props.keyStore].files.length, (newValue, oldValue) => {
      newValue === maxFiles ? (isLimitFilesCross.value = true) : (isLimitFilesCross.value = false);
    })

    return { pickFile, removeFile, state, isLimitFilesCross }
  }
}
</script>

<style lang="scss" scoped>
.label {
  text-align: left;
}

.upload-files {
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  background-color: #fcfcfc;
  border: 1px dashed #ccc;
  padding: 1em;
  margin-bottom: 1em;

  > div {
    margin-bottom: 1em;
  }

  .files {
    .file {
      padding: 0.5em;
      text-align: left;
      border-bottom: 1px solid gainsboro;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      font-size: 14px;
    }

    #delete-file {
      padding: 0;
      background-color: transparent;
      border: none;
    }
  }
}

.upload-files:hover {
  cursor: pointer;
}
</style>